import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { setLenis, scrollToTop } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import CampaignBanner from "@/components/CampaignBanner";
import AgentWidget from "@/components/agent/AgentWidget";
import Home from "@/pages/Home";
import ResortPage from "@/pages/ResortPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import AdminPage from "@/pages/admin/AdminPage";

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollToTop(true);
    }, [pathname]);
    return null;
}

/** Banner de campanha promocional: exibido apenas na página inicial. */
function CampaignGate() {
    const { pathname } = useLocation();
    return pathname === "/" ? <CampaignBanner /> : null;
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        setLenis(lenis);
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollManager />
            <div className="min-h-screen bg-sand font-sans text-[#1E2421] antialiased">
                <div className="grain-overlay" aria-hidden="true" />
                <CampaignGate />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/resorts/:slug" element={<ResortPage />} />
                        <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
                        <Route path="/descadastro" element={<UnsubscribePage />} />
                        <Route path="/admin/*" element={<AdminPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
                <Footer />
                <AgentWidget />
                <FloatingWhatsApp />
                <Toaster position="top-center" richColors closeButton />
            </div>
        </BrowserRouter>
    );
}
